import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Breadcrumb, PaymentNavCardsAndCarousel } from '@ibk/shared-ui';
import { pagamentosTranslations } from '../../translations';
import styles from './Home.module.css';
export function HomeBase(props) {
    const dataTestId = 'main-pagamentos-home';
    const { t } = useTranslation();
    function translateBreadcrumbs(breadcrumbs) {
        return breadcrumbs.map(item => ({
            ...item,
            label: t(item.label),
        }));
    }
    const translatedBreadcrumbs = props.breadcrumbs ? translateBreadcrumbs(props.breadcrumbs) : undefined;
    return (_jsxs("div", { className: `${styles.contentLayout}`, "data-testid": 'viewContentLayoutContainer', children: [translatedBreadcrumbs && translatedBreadcrumbs.length > 0 && (_jsx(Breadcrumb, { items: translatedBreadcrumbs, "data-testid": 'viewContentLayoutBreadcrumb' })), _jsxs("div", { className: `${styles.cardsContainer}`, "data-testid": 'viewContentLayoutCardsContainer', children: [_jsx("main", { className: styles.mainCard, "data-testid": dataTestId, children: props.accountsPayable }), _jsx("aside", { className: styles.sidebarCard, "data-testid": 'viewContentLayoutSidebar', children: _jsx(PaymentNavCardsAndCarousel, { isActive: true }) })] })] }));
}
export function Home(props) {
    return (_jsx(TranslationProvider, { translations: pagamentosTranslations, defaultLanguage: 'pt-BR', children: _jsx(HomeBase, { ...props }) }));
}
